// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

// Import Tailwind CSS
import "./index.css"; // or wherever you keep your tailwind imports
import "./App.css";
// e.g. @tailwind base; @tailwind components; @tailwind utilities;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
